// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__2beyZ","closeCrossGray":"styles_closeCrossGray__2y4sB","closeCrossRed":"styles_closeCrossRed__1VpD8","closeCross":"styles_closeCross__VL4wC"};